import PropTypes from 'prop-types';

var Variants;
(function (Variants) {
    Variants["PRIMARY"] = "primary";
    Variants["SECONDARY"] = "secondary";
    Variants["NEGATIVE"] = "negative";
})(Variants || (Variants = {}));
var propTypes = {
    variant: PropTypes.oneOf([
        Variants.PRIMARY,
        Variants.SECONDARY,
        Variants.NEGATIVE,
    ]),
};
var defaultProps = {
    variant: Variants.PRIMARY,
};

export { Variants, defaultProps, propTypes };
